"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailData = void 0;
const resource_model_1 = require("./resource.model");
class EmailData extends resource_model_1.Resource {
    load(x) {
        super.load(x);
        this.subject = this.clean(x.subject, String);
        this.content = this.clean(x.content, String);
        this.to = x.to && typeof x.to === 'string' ? this.clean(x.to, String).split(',') : this.cleanArray(x.to, String);
        this.cc = x.cc && typeof x.cc === 'string' ? this.clean(x.cc, String).split(',') : this.cleanArray(x.cc, String);
        this.bcc =
            x.bcc && typeof x.bcc === 'string' ? this.clean(x.bcc, String).split(',') : this.cleanArray(x.bcc, String);
    }
}
exports.EmailData = EmailData;
